import React from "react";
import { Modal } from "react-native";
import { Box } from "app/components/common";

export const FullScreenModal = ({ isVisible, onClose, children }) => {
  return (
    <Modal visible={isVisible} animationType="slide" onRequestClose={onClose}>
      <Box flex={1} backgroundColor="neutral.white" paddingHorizontal="sm">
        {children}
      </Box>
    </Modal>
  );
};
